/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { MsAdalAngular6Module,AuthenticationGuard } from 'microsoft-adal-angular6';
import { MsalModule } from '@azure/msal-angular';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ModalModule } from 'ngx-bootstrap';

import { CaptchaModule } from 'ng-captcha';

import {AutocompleteLibModule} from 'angular-ng-autocomplete';

import { SharedModule } from './shared/shared.module';
import { AuthGuard } from './_guards';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AlertService, AuthenticationService, UserService,TdsSubmitService,PMSservice,PMS_goals_service,ApplicationForm } from './_services';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';;
;
import { HeaderComponent } from './header/header.component'
;
import { UploadComponent } from './upload/upload.component';
import { VerifyComponent } from './verify/verify.component';
import { ForgetpasswordComponent } from './forgetpassword';
import { AuthorizeComponent } from './authorize/authorize.component'
import { OAuthSettings } from '../oauth';
import { LogoutComponent } from './logout/logout.component';



@NgModule({
  declarations: [AppComponent,
    
    HomeComponent,
    LoginComponent,
    RegisterComponent,    
    HeaderComponent ,   
    UploadComponent, VerifyComponent, ForgetpasswordComponent,AuthorizeComponent, LogoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    CaptchaModule,
    AutocompleteLibModule,
    MsAdalAngular6Module.forRoot({
      tenant: '94c099b8-c0c6-4110-b50d-16482bc6ff71',
      clientId: 'e336c6a3-b8df-48e0-9dc8-4e55ecc6d4e5',
      redirectUri: window.location.origin,
      endpoints: {
          graphApiUri: "https://graph.microsoft.com",
        },
      navigateToLoginRequestUrl: false,
      cacheLocation: 'localStorage', 
    }),

    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    ModalModule.forRoot(),
    MsalModule.forRoot({
      clientID: OAuthSettings.appId,      

    })
  ],
  bootstrap: [AppComponent],
  providers: [
         AuthGuard,
        AlertService,
        AuthenticationService,
        AuthenticationGuard,
        UserService,
        TdsSubmitService,
        PMSservice,
        PMS_goals_service,
        ApplicationForm,
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
})
export class AppModule {
}
